<template>
  <e-charts :options="options"
            :init-options="{}"
            ref="charts"
            style="height: 200px;"
            autoresize />
</template>

<script>
import ECharts from '@/components/public/ECharts.vue'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/legendScroll'
import 'echarts/lib/component/title'
export default {
  name: 'pie-chart',
  components: { ECharts },
  props: {
    opts: {
      type: Object,
      default () {
        return {
        //   title: '测试',
          legend: [],
          series: [],
          selected: { }
        }
      }
    }
  },
  watch: {
    opts: {
      handler (val, oldVal) {
        // this.options.title.text = val.title
        this.options.legend.data = val.data
        this.options.legend.selected = val.selected
        this.options.series[0].data = val.series
      },
      immediate: true
    }
  },
  data () {
    return {
      options: {
        // title: {
        //   text: '同名数量统计',
        //   left: 'center'
        // },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c}'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 10,
          top: 20,
          bottom: 20,
          data: [],
          selected: []
        },
        series: [
          {
            name: '数量',
            type: 'pie',
            radius: '50%',
            center: ['25%', '50%'],
            data: [],
            label: {
              show: true
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }
  }
}
</script>

<style>
</style>
